/**
 * Payment Debug Logger
 * Enable via: sessionStorage.setItem('debugPayment', 'true')
 */
class DebugLogger {
  constructor() {
    this.STORAGE_KEY = 'debugPayment'
    this.PREFIX = '[PaymentDebugger]'
  }

  isDebugMode() {
    if (typeof window === 'undefined') return false
    return window.sessionStorage?.getItem(this.STORAGE_KEY) === 'true'
  }

  log(category, message, data) {
    if (!this.isDebugMode()) return

    const style =
      'background: #004d40; color: #fff; padding: 2px 4px; border-radius: 2px;'
    console.groupCollapsed(`%c${this.PREFIX} [${category}] ${message}`, style)
    if (data !== undefined) console.log('Data:', data)
    console.trace('Stack Trace')
    console.groupEnd()
  }

  warn(category, message, data) {
    if (!this.isDebugMode()) return

    const style =
      'background: #e65100; color: #fff; padding: 2px 4px; border-radius: 2px;'
    console.groupCollapsed(`%c${this.PREFIX} [${category}] ${message}`, style)
    if (data !== undefined) console.warn('Data:', data)
    console.groupEnd()
  }

  error(category, message, error) {
    if (!this.isDebugMode()) {
      console.error(`${this.PREFIX} [${category}] ${message}`, error)
      return
    }

    const style =
      'background: #b71c1c; color: #fff; padding: 2px 4px; border-radius: 2px;'
    console.groupCollapsed(`%c${this.PREFIX} [${category}] ${message}`, style)
    console.error(error)
    console.groupEnd()
  }

  breakpoint(reason) {
    if (!this.isDebugMode()) return

    console.log(
      `%c${this.PREFIX} [Breakpoint] 🛑 Pausing for: ${reason}`,
      'color: red; font-weight: bold; font-size: 1.2em;'
    )
    // eslint-disable-next-line no-debugger
    debugger
  }
}

export const debugLogger = new DebugLogger()
export default debugLogger
